export default __webpack_public_path__ + "media/assets/img/icon_img_big-e90e14e8c1f57fefab07cca99563fde2.png";